// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card-name[data-v-033fd44e]{height:100px}.card[data-v-033fd44e]{margin-top:24px}.card .container-rows .rows[data-v-033fd44e]{display:flex}.card .container-rows .rows .row-data-gray[data-v-033fd44e]{width:100%;background-color:var(--pult-bg);padding:8px}.card .container-rows .rows .row-data-white[data-v-033fd44e]{width:100%;padding:8px}.line[data-v-033fd44e]{margin-bottom:35px;margin-top:35px;height:1px;background-color:var(--pult-line)}", ""]);
// Exports
module.exports = exports;
